import { render, staticRenderFns } from "./consumerUser.vue?vue&type=template&id=37448070&scoped=true&"
import script from "./consumerUser.vue?vue&type=script&lang=js&"
export * from "./consumerUser.vue?vue&type=script&lang=js&"
import style0 from "./consumerUser.vue?vue&type=style&index=0&id=37448070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37448070",
  null
  
)

export default component.exports